<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('SERVICO')"
          :class="['nav-link link-nav-resident', step == 'SERVICO' && 'active']"
          id="nav-service"
          data-toggle="tab"
          href="#service"
          role="tab"
          aria-controls="service"
          aria-selected="true"
          >SERVIÇO</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'SERVICO'"
        :class="['tab-pane fade', step == 'SERVICO' && 'show active']"
        id="servico"
        role="tabpanel"
        aria-labelledby="nav-servico"
      >
        <service :resident="resident" />
      </div>
    </div>
  </div>
</template>

<script>
import Service from "./service/service.vue";

import routes from "../../../routes";

export default {
  name: "MenuService",

  components: {
    Service,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "SERVICO",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newNav;

      if (step == "SERVICO") {
        newNav = "service";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "service") {
          this.step = "SERVICO";
        }
      }
    },
  },
};
</script>